<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/2xiNoW/tc-custom/9781504010351.jpg?1702063716766" alt="This image is the cover for the book Hothouse"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Hothouse
      </h1>
      <p class="bookDescription body article font2">
        <b>A Hugo Award–winning classic about a far-future Earth dominated by gargantuan plants and the few humans who remain</b><br/><br/> Millions of years beyond our time, our Earth has long since stopped spinning—and giant flora have taken over the sunlit half of the motionless world. Here humans are among the very few animal species that still exist, struggling to survive against enormous odds, but they have become small and weak, and their numbers have dwindled to almost nothing. When the aging leader of Gren’s tribe decrees it is time for the old ones to go “Up,” the younger are left to make their own way below. Although the journey will not be an easy one for young Gren, he sets off on an odyssey across a perilous world populated by carnivorous plants and other evolved vegetation. But any knowledge to be gained at the terminator—the forbidding boundary between the day world and the night—might well prove worthless for the boy and the companions he amasses along the way when the expanding sun goes nova and their Earth is no more.<br/>  <br/> A thrilling parable of courage, discovery, and survival, <i>Hothouse</i> is among Grand Master Brian W. Aldiss’s most beloved and enduring works. Ingeniously inventive, richly detailed, and breathtakingly lush and vibrant, the doomed world and people that Aldiss creates will live forever in the minds of all those who enter this remarkable realm.<br/>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Brian W. Aldiss
      </h2>
      
      <p class="authorDescription body article">Brian W. Aldiss was born in Norfolk, England, in 1925. Over a long and distinguished writing career, he published award‑winning science fiction (two Hugo Awards, a Nebula Award, and the John W. Campbell Memorial Award); bestselling popular fiction, including the three‑volume Horatio Stubbs saga and the four‑volume the Squire Quartet; experimental fiction such as <I>Report on Probability A</I> and <I>Barefoot in the Head</I>; and many other iconic and pioneering works, including the Helliconia Trilogy. He edited many successful anthologies and published groundbreaking nonfiction, including a magisterial history of science fiction (<I>Billion Year Spree</I>, later revised and expanded as <I>Trillion Year Spree</I>). Among his many short stories, perhaps the most famous was &ldquo;Super‑Toys Last All Summer Long,&rdquo; which was adapted for film by Stanley Kubrick and produced and directed after Kubrick&rsquo;s death by Steven Spielberg as <I>A.I. Artificial Intelligence</I>.&#160;Brian W. Aldiss passed away in 2017 at the age of 92.&#160;</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Integrated Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?61d8b6c7